var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":_vm.link}},[(_vm.type == 'logo')?_c('b-img-lazy',_vm._b({staticClass:"site-logo",attrs:{"src":_vm.logo,"fluid":"","alt":_vm.alt}},'b-img-lazy',{ blank: true },false)):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }